import {connect} from 'react-redux';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import {withRouter} from 'react-router';
import {FormFieldProps} from '../../../../common/types/components';
import * as WizardActions from '../../../actions/WizardActions';
import PersonalDataSectionView from '../../../components/views/mx/turboCash/PersonalDataSectionView';

const mapStateToProps = (state, {match, showErrors}) => {
    const personal = state.turboCash.loanApplication.applicantPersonal;
    const personalDataStepViewFieldErrorState = state.turboCash.ui.personalDataStepView.fieldErrors;
    const {countrySelector, catalogs} = state;
    return {
        catalogs,
        showErrors,
        civilStatus: catalogs.civilStatus,
        regime: catalogs.regime,
        rolHome: catalogs.rolHome,
        studies: catalogs.studies,
        houseType: catalogs.houseType,
        lapse: catalogs.lapse,
        civilStatusSelectedField: new FormFieldProps(
            personal.civilStatus, personalDataStepViewFieldErrorState.civilStatusFieldError),
        regimeSelectedField: new FormFieldProps(
            personal.regime, personalDataStepViewFieldErrorState.regimeFieldError),
        rolHomeSelectedField: new FormFieldProps(
            personal.rolHome, personalDataStepViewFieldErrorState.rolHomeFieldError),
        studiesSelectedField: new FormFieldProps(
            personal.studies, personalDataStepViewFieldErrorState.studiesFieldError),
        houseTypeSelectedField: new FormFieldProps(
            personal.houseType, personalDataStepViewFieldErrorState.houseTypeFieldError),
        amountDependentsField: new FormFieldProps(
            personal.amountDependents, personalDataStepViewFieldErrorState.amountDependentsFieldError),
        cURPField: new FormFieldProps(
            personal.cURP, personalDataStepViewFieldErrorState.cURPFieldError),
        countrySelected: countrySelector.countrySelected,
        loanApplicationToken: match.params.token
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChangeCivilStatus: (civilStatus, error) => {
            dispatch(WizardActions.CHANGE_CIVIL_STATUS_ACTION.action(civilStatus, error));
        },
        onChangeRegime: (regime, error) => {
            dispatch(WizardActions.CHANGE_REGIME_ACTION.action(regime, error));
        },
        onChangeRolHome: (rolHome, error) => {
            dispatch(WizardActions.CHANGE_ROL_HOME_ACTION.action(rolHome, error));
        },
        onChangeStudies: (studies, error) => {
            dispatch(WizardActions.CHANGE_STUDIES_ACTION.action(studies, error));
        },
        onChangeHouseType: (houseType, error) => {
            dispatch(WizardActions.CHANGE_HOUSE_TYPE_ACTION.action(houseType, error));
        },
        onChangeAmountDependents: (amountDependents, error) => {
            dispatch(WizardActions.CHANGE_AMOUNT_DEPENDENTS_ACTION.action(amountDependents, error));
        },
        onChangeCURP: (cURP, error) => {
            dispatch(WizardActions.CHANGE_CURP_ACTION.action(cURP, error));
        }
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps
    };
};

const PersonalDataSectionContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(PersonalDataSectionView));

export default PersonalDataSectionContainer;